import { dew as _index3Dew } from "../generated/index.js";
import { dew as _removeTypeDuplicates2Dew } from "../../modifications/typescript/removeTypeDuplicates.js";
import { dew as _index4Dew } from "../../validators/generated/index.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = createTSUnionType;
  var _index = _index3Dew();
  var _removeTypeDuplicates = _removeTypeDuplicates2Dew();
  var _index2 = _index4Dew();
  function createTSUnionType(typeAnnotations) {
    const types = typeAnnotations.map(type => {
      return (0, _index2.isTSTypeAnnotation)(type) ? type.typeAnnotation : type;
    });
    const flattened = (0, _removeTypeDuplicates.default)(types);
    if (flattened.length === 1) {
      return flattened[0];
    } else {
      return (0, _index.tsUnionType)(flattened);
    }
  }

  //# sourceMappingURL=createTSUnionType.js.map
  return exports;
}